require('./permissionsEditorHeader.i18n.json');
require('./permissionsEditorHeader.tpl.html');
require('./permissionsEditorHeaderController.js');

const PermissionsEditorHeaderComponent = {
    templateUrl: '/configuration/permissionsEditor/header/permissionsEditorHeader.tpl.html',
    controller: 'permissionsEditorHeaderController',
    bindings: {
        userType: '<',
        hasManagePermission:'&'
    }
};

angular.module('ums.configuration')
    .component('uiPermissionsEditorHeader', PermissionsEditorHeaderComponent);
